/*! @azure/msal-common v16.9.0 2026-06-16 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.9.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
